import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env } from '@noor/config';
import { catalogSearchSchema, type CatalogSearch } from '@/entities/storefront';
import { CatalogPage } from '@/pages/catalog-management';

export const Route = createFileRoute('/catalog/categories')({
  staticData: { permission: 'catalog.categories.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  validateSearch: catalogSearchSchema,
  component: CatalogCategoriesRoute,
});
function CatalogCategoriesRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onSearchChange = (next: Partial<CatalogSearch>) =>
    void navigate({
      search: (previous) => ({
        ...previous,
        ...next,
        ...(!('page' in next) ? { page: 1 } : {}),
      }),
    });
  return (
    <CatalogPage entity="categories" search={search} onSearchChange={onSearchChange} />
  );
}
